"use client";

import { useSyncExternalStore } from "react";

const EMPTY_SEARCH_PARAMS = new URLSearchParams();
let cachedSearch: string | null = null;
let cachedParams: URLSearchParams = EMPTY_SEARCH_PARAMS;

function subscribe(onChange: () => void) {
  window.addEventListener("popstate", onChange);
  return () => window.removeEventListener("popstate", onChange);
}

function getClientSnapshot(): URLSearchParams {
  const search = window.location.search;
  if (search !== cachedSearch) {
    cachedSearch = search;
    cachedParams = new URLSearchParams(search);
  }
  return cachedParams;
}

function getServerSnapshot(): URLSearchParams {
  return EMPTY_SEARCH_PARAMS;
}

export function useWindowSearchParams(): URLSearchParams {
  return useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
}
